import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./css/index.scss";
import CONST from "./../../util/const";
import _ from "lodash";
import facebookSvg from "./../../assets/svg/facebook.svg";
import twitterSvg from "./../../assets/svg/twitter.svg";
import googleSvg from "./../../assets/svg/google-plus.svg";

class Footer extends Component {
  props;

  render() {
    return (
      <footer className="footer">
        <div className="hsection" style={{ display: "flex" }}>
          <div className="logo"></div>
          <div className="title">taburi</div>
        </div>
        <div className="hsection" style={{ display: "flex" }}>
          <a
            className="fb"
            target="_blank"
            style={{ padding: "0", lineHeight: "22px" }}
            href="https://www.facebook.com/taburi.ro"
          >
            <img
              src={facebookSvg}
              style={{ height: "28px", marginRight: "5px" }}
              alt=""
            />
          </a>
          <a
            className="fb"
            target="_blank"
            style={{ padding: "0", lineHeight: "22px" }}
            href="https://twitter.com/taburi_ro"
          >
            <img
              src={twitterSvg}
              style={{ height: "28px", marginRight: "0px" }}
              alt=""
            />
          </a>
          <a
            className="fb"
            target="_blank"
            style={{ padding: "0", lineHeight: "22px" }}
            href="https://plus.google.com/110915271894973574963"
          >
            <img
              src={googleSvg}
              style={{ height: "28px", marginRight: "0px" }}
              alt=""
            />
          </a>
        </div>
        <div className="hsection" style={{ display: "flex" }}>
          {CONST.letters.map((letter) => {
            return (
              <Link
                key={letter}
                onClick={() => {
                  this.props.clearArtistsByLetter();
                }}
                style={{ flexGrow: "1" }}
                to={`/artisti/${letter}`}
              >
                {letter === "nl" ? `#` : _.capitalize(letter)}
              </Link>
            );
          })}
        </div>
        <div className="hsection">
          <div>
            Copyright &copy; 2011-2021 taburi.ro -{" "}
            <Link to="/termeni-si-conditii">Termeni și condiții</Link>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js